import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { IconCopy } from "@tabler/icons-react";
import { CButton } from "@app/components/Common";
import { COLORS } from "@app/constants";
import { Text, View } from "@/styles/reactnative";
import { useDepositStore } from "../../../../hooks/deposit/store";
import { useFetcher } from "../../../../hooks/fetcher";
import { useToken, useWindowDimensions } from "@app/hooks";
import { copyTextToClipboard } from "../../../../../utils/ciutils";
import { useMyProfile } from "../../../../hooks/user/myprofile";
import { useIsMobile } from '@utils/CalVW.tsx';
import { message } from 'antd';

const DepositWalletAddress = () => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const [walletAddress, setWalletAddress] = useState<string>("");
  const isMobile = useIsMobile();

  const { data: depositStore } = useDepositStore({
    network: "TRC20",
    coin: "USDT",
  });

  const { data: myprofile } = useMyProfile();

  const { data: res } = useFetcher(
    depositStore?.coin === "KRW"
      ? null
      : `/user/my/wallet?coin=${depositStore?.coin}&network=${depositStore?.network}`,
  );

  const vaccount = myprofile?.vaccount?.replace(/undefined/g, "");

  let bank = vaccount?.split("/")?.[0] || "";
  let account = vaccount?.split("/")?.[1] || "";
  let name = vaccount?.split("/")?.[2] || "";

  useEffect(() => {
    if(depositStore?.coin === "KRW") {
      setWalletAddress(vaccount);
    } else {
      if(res?.result?.result?.wallet_address){
        setWalletAddress(res?.result?.result?.wallet_address)
      }
    }

  }, [res]);

  // const walletAddress =
  //   depositStore?.coin === "KRW"
  //     ? vaccount
  //     : res?.result?.result?.wallet_address || "";

  if (depositStore?.coin !== "KRW") {
    bank = "";
    name = "";
    account = walletAddress;
  }

  // useEffect(() => {
  //   console.log('vaccount', vaccount);
  //   console.log('bank', bank);
  //   console.log('account', account);
  //   console.log('name', name);
  //   console.log('res', res);
  //   console.log('depositStore', depositStore);
  //   console.log('walletAddress', walletAddress);
  //
  // }, [walletAddress])

  const handleCopyClick = () => {
    const addressToCopy = depositStore?.coin == "KRW" ? account : walletAddress;
    
    // 주소가 비어있으면 함수 실행 중단
    if (!addressToCopy || addressToCopy.trim() === '') {
      return;
    }
    
    if(isMobile){
      toast(`${t("copiedSuccessfully")}`);
    } else {
      message.success(`${t("copiedSuccessfully")}`);
    }

    copyTextToClipboard(addressToCopy);
  };

  return (
    <View
      style={{
        width: "100%",
        alignItems: "flex-start",
        justifyContent: "flex-start",
      }}
    >
      <Text>{t("walletAddress")}</Text>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          border: `1px solid ${COLORS.primary}`,
          width: "100%",
          borderRadius: 5,
          marginTop: 10,
        }}
      >
        {depositStore?.coin == "KRW" && !myprofile?.vaccount ? (
          <></>
        ) : (
          <>
            <View
              style={{
                width: "88%",
                flexDirection: depositStore?.coin == "KRW" ? "row" : "column",
                alignItems: "flex-start",
                paddingInline: 10,
              }}
            >
              {bank && (
                <>
                  <Text
                    size={width > 900 ? 12 : 13}
                    style={{
                      color: COLORS.secondary,
                      paddingRight: 10,
                    }}
                  >
                    {bank}
                  </Text>
                  <View style={{ marginRight: 10 }}>/</View>
                </>
              )}
              <Text
                size={width > 900 ? 12 : 13}
                style={{ color: COLORS.secondary, width: "100%", display: 'flex', justifyContent: 'start', overflow: 'hidden' }}
              >
                {depositStore?.coin === "KRW" ? account : walletAddress}
              </Text>
              {name && (
                <>
                  <View style={{ marginLeft: 10 }}>/</View>
                  <Text
                    size={width > 900 ? 12 : 13}
                    style={{
                      color: COLORS.secondary,
                      paddingLeft: 10,
                    }}
                  >
                    {name}
                  </Text>
                </>
              )}
            </View>
            <CButton
              onClick={handleCopyClick}
              icon={<IconCopy size={18} />}
              style={{
                width: "35px",
                height: "15px",
                paddingBlock: 10,
                background: 'none',
                color:'#b5b5bc',
                marginRight: 5,
                cursor: "pointer",
              }}
            />
          </>
        )}
      </View>
    </View>
  );
};

export default DepositWalletAddress;
